import { StepType } from ".";

export type InterventionStep = {
  id?: string;
  prompt?: string;
  type?: StepType;
  answers?: string[];
  mediaType?: InterventionStepMediaType;
  mediaUrl?: string;
};

export type SingleChoiceOption = {
  // options are unique by answer
  answer: string;
  nextStepOverride?: InterventionStepBranching | null;
  weight?: number;
};

type SingleChoiceStepConfiguration = {
  metricName?: string;
  options: SingleChoiceOption[];
};

type MultipleChoiceStepConfiguration = {
  answers: string[];
};
export enum InterventionStepMediaType {
  image = "image",
  pdf = "pdf",
}
type MediaStepConfiguration = {
  mediaUrl: string;
  mediaType: InterventionStepMediaType;
};
type BaseStepConfiguration = {};

export enum InterventionDeliveryMethod {
  chatcbt = "chatbot",
  llm = "llm",
  spontaneous = "spontaneous",
}

type BaseInterventionStep = {
  id: string;
  prompt: string;
  // intervention: Intervention;
  nextStep?: InterventionStepBranching;
};

type ActivityStep = BaseInterventionStep & {
  type: StepType.activity;
  configuration: BaseStepConfiguration;
};
type EmotionStep = BaseInterventionStep & {
  type: StepType.emotion;
  configuration: BaseStepConfiguration;
};
type FreeTextStep = BaseInterventionStep & {
  type: StepType.freeText;
  configuration: BaseStepConfiguration;
};
type InformationalStep = BaseInterventionStep & {
  type: StepType.informational;
  configuration: BaseStepConfiguration;
};
export type MultipleChoiceStep = BaseInterventionStep & {
  type: StepType.multipleChoice;
  configuration: MultipleChoiceStepConfiguration;
};
export type SingleChoiceStep = BaseInterventionStep & {
  type: StepType.singleChoice;
  configuration: SingleChoiceStepConfiguration;
};
export type WeightedSingleChoiceStep = BaseInterventionStep & {
  type: StepType.weightedSingleChoice;
  configuration: SingleChoiceStepConfiguration;
};
type SliderStep = BaseInterventionStep & {
  type: StepType.slider;
  configuration: BaseStepConfiguration;
};
type MediaStep = BaseInterventionStep & {
  type: StepType.media;
  configuration: MediaStepConfiguration;
};
type ThoughtStep = BaseInterventionStep & {
  type: StepType.thought;
  configuration: BaseStepConfiguration;
};

export type InterventionStepBranching =
  | ActivityStep
  | EmotionStep
  | FreeTextStep
  | InformationalStep
  | MultipleChoiceStep
  | SingleChoiceStep
  | WeightedSingleChoiceStep
  | SliderStep
  | MediaStep
  | ThoughtStep;

export type Branch = {
  id: string;
  isMainBranch: boolean;
  name: string;
  initialStep?: {
    id?: string;
  };
  deleted?: boolean;
  steps: InterventionStepBranching[];
};

export interface StepConfigInput {
  informational?: BaseStepConfigInput;
  freeText?: BaseStepConfigInput;
  emotion?: BaseStepConfigInput;
  thought?: BaseStepConfigInput;
  activity?: BaseStepConfigInput;
  singleChoice?: ChoiceStepConfigInput;
  weightedSingleChoice?: WeightedSingleChoiceStepConfigInput;
  multipleChoice?: ChoiceStepConfigInput;
  slider?: SliderConfigInput;
  media?: InterventionStepMediaConfigInput;
}

interface ChoiceStepConfigInput {
  branchId?: string | number;
  prompt: string;
  previousStepId?: string | number;
  nextStepId?: string | number;
  answers: string[];
  interventionId?: string | number;
}

interface BaseStepConfigInput {
  branchId?: string | number;
  prompt: string;
  previousStepId?: string | number;
  nextStepId?: string | number;
  interventionId?: string | number;
}

interface WeightedSingleChoiceOptionInput {
  answer: string;
  weight: number;
}

interface WeightedSingleChoiceStepConfigInput {
  branchId?: string | number;
  prompt: string;
  previousStepId?: string | number;
  nextStepId?: string | number;
  options: WeightedSingleChoiceOptionInput[];
  metricName: string;
  interventionId?: string | number;
}
interface SliderLabelInput {
  label: string;
  value: number;
}

interface SliderConfigInput {
  branchId?: string | number;
  prompt: string;
  previousStepId?: string | number;
  nextStepId?: string | number;
  max: number;
  min: number;
  labels: SliderLabelInput[];
  interventionId?: string | number;
}

interface InterventionStepMediaConfigInput {
  branchId?: string | number;
  previousStepId?: string | number;
  nextStepId?: string | number;
  mediaType: InterventionStepMediaType;
  mediaUrl: string;
  interventionId?: string | number;
}
